import clsx from "clsx";
import { useState } from "react";
import StepProgressbar from "ui/customers/step-progressbar";
import StepProgressbarV3 from "ui/automation/step-progressbar";
import { SvgNvr, SvgEdgeCamera } from "ui/svgs";
import TopNav from "ui/dashboard/topnav";
import { Radio } from "antd";
import { Link, useLocation, useParams } from "react-router-dom";
const radioValue1 = "nvr";
const radioValue2 = "edge-camera";
export default function Page() {
  // const orgId = params.orgid;
  const { orgid, siteid } = useParams();
  const { state } = useLocation();
  const orgId = orgid!;
  const siteName = state?.siteName || "New Site";
  const [radioValue, setRadioValue] = useState(radioValue1);

  const handleChange = (e) => {
    console.log("Selected option:", e.target.value);
    setRadioValue(e.target.value);
  };

  return (
    <>
      <TopNav title="Customer Management" />
      <div className="flex-grow pr-6 pb-6">
        <div className="w-full h-full p-6 rounded-3xl bg-white">
          <div className="max-w-lg mx-auto">
            {radioValue === radioValue1 ? (
              <StepProgressbar step={2} />
            ) : (
              <StepProgressbarV3 step={2} />
            )}
            <h2 className="mt-4 text-lg font-medium mb-5">
              Select Device Type for site [{siteName}]
            </h2>
            <div className="flex flex-col gap-4">
              <Radio.Group
                onChange={handleChange}
                value={radioValue}
                className="w-full"
              >
                <div className="flex flex-col gap-4 w-full cursor-pointer">
                  <div
                    className={clsx(
                      `flex items-center p-6 rounded-2xl bg-[#F6F8FA] border `,
                      radioValue === radioValue1
                        ? "border-blue-400"
                        : "hover:border-blue-400 border-transparent",
                    )}
                    onClick={() => setRadioValue(radioValue1)}
                  >
                    <Radio value={radioValue1} className="mt-1" />
                    <div className="ml-4 flex flex-col gap-2 text-[#222222]">
                      <SvgNvr width="24" className="fill-[#222222]" />
                      <p className="text-base font-medium">Add NVR</p>
                      <p className="text-sm ">
                        Use an NVR to connect and manage IP cameras and other
                        security devices.
                      </p>
                    </div>
                  </div>

                  {/* Edge Camera 选项 */}
                  <div
                    className={clsx(
                      `flex items-center p-6 rounded-2xl bg-[#F6F8FA] border`,
                      radioValue === radioValue2
                        ? "border-blue-400"
                        : "hover:border-blue-400 border-transparent",
                    )}
                    onClick={() => setRadioValue(radioValue2)}
                  >
                    <Radio value={radioValue2} className="mt-1" />
                    <div className="ml-4 flex flex-col gap-2 text-[#222222]">
                      <SvgEdgeCamera width="24" className="fill-[#222222]" />
                      <p className="text-base font-medium">Add Edge Camera</p>
                      <p className="text-sm ">
                        Connect Edge Cameras directly to the cloud — no NVR
                        needed.
                      </p>
                    </div>
                  </div>
                </div>
              </Radio.Group>
            </div>
            <div className="mt-6 flex justify-end gap-4">
              <Link
                to="/dashboard/customers"
                className="p-4 flex items-center rounded-2xl bg-gray-100 px-6 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-200"
              >
                Cancel
              </Link>
              <Link
                className={clsx(
                  "py-4 px-6 rounded-2xl bg-[#3E83F6] text-base font-medium text-white  hover:bg-blue-400",
                )}
                to={
                  radioValue === radioValue1
                    ? `/dashboard/customers/${orgId}/sites/${siteid}/nvrs/create`
                    : `/dashboard/customers/${orgId}/sites/${siteid}/edge-cameras/create`
                }
              >
                Continue
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
